import { Check } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, Kicker } from "@/components/Reveal";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-24 sm:py-32 scroll-mt-20" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <Kicker>{t.about.kicker}</Kicker>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-slate-50 leading-tight">
            {t.about.title}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">{t.about.body}</p>
          <ul className="mt-8 space-y-4" data-testid="about-promise-list">
            {t.about.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-slate-200">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 ring-1 ring-gold/40">
                  <Check size={12} className="text-gold" />
                </span>
                <span className="text-sm sm:text-base">{b}</span>
              </li>
            ))}
          </ul>
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6" data-testid="about-stats">
            {t.about.stats.map((s) => (
              <div key={s.l} className="border-l gold-hairline pl-4">
                <p className="font-display text-3xl text-gold-gradient font-semibold">{s.n}</p>
                <p className="mt-1 text-xs uppercase tracking-widest text-slate-500">{s.l}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="relative">
          <div className="relative mx-auto max-w-md">
            <div className="absolute -inset-4 rounded-t-[999px] rounded-b-3xl bg-gradient-to-b from-gold/25 to-transparent blur-2xl" />
            <div className="relative overflow-hidden rounded-t-[999px] rounded-b-3xl ring-1 ring-gold/40 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
              <img src="/assets/taj-mahal.jpg" alt="Taj Mahal, Agra" className="h-[480px] sm:h-[560px] w-full object-cover hover:scale-105 transition-transform duration-[1.5s]" />
            </div>
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 glass-card rounded-full px-6 py-3 ring-1 ring-gold/30 whitespace-nowrap">
              <span className="font-display text-gold-light tracking-widest text-sm">TAJ MAHAL · AGRA</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
